import { TemplateRef } from '@angular/core';
import { BaseComponent } from '../../shared/base.component';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SessionStorageService } from "ngx-webstorage";
import { UserService } from '../../core/user/user.service';
import { UserVoucherService } from '../user-voucher/user-voucher.service';
import { JhiEventManager } from '../../ng-jhipster/service';
import { SessionService } from '../session/session.service';
import { ActivatedRoute, Router } from "@angular/router";
import { PaymentService } from '../payment/payment.service';
import { PricingService } from '../pricing/pricing.service';
import { TrackerService } from '../../core/tracker/tracker.service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/user/user.service";
import * as i2 from "../../ng-jhipster/service";
import * as i3 from "../user-voucher/user-voucher.service";
import * as i4 from "ngx-webstorage";
import * as i5 from "@ng-bootstrap/ng-bootstrap";
import * as i6 from "../pricing/pricing.service";
import * as i7 from "../session/session.service";
import * as i8 from "@angular/router";
import * as i9 from "../payment/payment.service";
import * as i10 from "../../core/tracker/tracker.service";
import * as i11 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i12 from "@angular/common";
import * as i13 from "@fortawesome/angular-fontawesome";
import * as i14 from "@angular/forms";
import * as i15 from "@ngx-translate/core";
const _c0 = ["voucherFormModal"];
const _c1 = ["paymentFormModal"];
function UserPaymentComponent_div_16_tr_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const uv_r6 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(uv_r6.voucher.code);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(uv_r6.numberOfSessionsLeft);
} }
function UserPaymentComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "table", 16);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr");
    i0.ɵɵelementStart(4, "th", 17);
    i0.ɵɵelement(5, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th", 17);
    i0.ɵɵelement(7, "span", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "tbody");
    i0.ɵɵtemplate(9, UserPaymentComponent_div_16_tr_9_Template, 5, 2, "tr", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngForOf", ctx_r0.currentUserVouchers);
} }
function UserPaymentComponent_ng_template_17_div_1_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 35);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("jhiTranslate", ctx_r12.errorMessage);
} }
function UserPaymentComponent_ng_template_17_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "fa-icon", 24);
    i0.ɵɵlistener("click", function UserPaymentComponent_ng_template_17_div_1_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r15); const modal_r8 = i0.ɵɵnextContext().$implicit; const ctx_r13 = i0.ɵɵnextContext(); modal_r8.close("close"); return ctx_r13.errorMessage = null; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "br");
    i0.ɵɵelement(3, "h5", 25);
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "form", 26, 27);
    i0.ɵɵlistener("ngSubmit", function UserPaymentComponent_ng_template_17_div_1_Template_form_ngSubmit_5_listener() { i0.ɵɵrestoreView(_r15); const _r11 = i0.ɵɵreference(6); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.onVoucherAddition(_r11); });
    i0.ɵɵelementStart(7, "div", 28);
    i0.ɵɵelementStart(8, "input", 29);
    i0.ɵɵlistener("click", function UserPaymentComponent_ng_template_17_div_1_Template_input_click_8_listener() { i0.ɵɵrestoreView(_r15); const ctx_r17 = i0.ɵɵnextContext(2); return ctx_r17.errorMessage = null; });
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 30);
    i0.ɵɵtemplate(11, UserPaymentComponent_ng_template_17_div_1_span_11_Template, 1, 1, "span", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "br");
    i0.ɵɵelementStart(13, "div", 32);
    i0.ɵɵelement(14, "button", 33);
    i0.ɵɵelementStart(15, "button", 34);
    i0.ɵɵlistener("click", function UserPaymentComponent_ng_template_17_div_1_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r15); const modal_r8 = i0.ɵɵnextContext().$implicit; const ctx_r18 = i0.ɵɵnextContext(); modal_r8.close("close"); return ctx_r18.errorMessage = null; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(8);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(9, 2, "global.form.voucher.placeholder"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r9.errorMessage);
} }
function UserPaymentComponent_ng_template_17_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelementStart(1, "fa-icon", 24);
    i0.ɵɵlistener("click", function UserPaymentComponent_ng_template_17_div_2_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r22); const modal_r8 = i0.ɵɵnextContext().$implicit; const ctx_r20 = i0.ɵɵnextContext(); modal_r8.close("close"); ctx_r20.errorMessage = null; return ctx_r20.isSuccessful = false; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "br");
    i0.ɵɵelement(3, "h5", 36);
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "button", 34);
    i0.ɵɵlistener("click", function UserPaymentComponent_ng_template_17_div_2_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r22); const modal_r8 = i0.ɵɵnextContext().$implicit; const ctx_r23 = i0.ɵɵnextContext(); modal_r8.close("close"); ctx_r23.errorMessage = null; return ctx_r23.isSuccessful = false; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function UserPaymentComponent_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, UserPaymentComponent_ng_template_17_div_1_Template, 16, 4, "div", 22);
    i0.ɵɵtemplate(2, UserPaymentComponent_ng_template_17_div_2_Template, 6, 0, "div", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isSuccessful);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isSuccessful);
} }
function UserPaymentComponent_ng_template_19_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵelementStart(2, "input", 48);
    i0.ɵɵlistener("click", function UserPaymentComponent_ng_template_19_div_1_div_7_Template_input_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r34); const priceElement_r31 = restoredCtx.$implicit; const i_r32 = restoredCtx.index; const ctx_r33 = i0.ɵɵnextContext(3); ctx_r33.errorMessage = null; ctx_r33.selectedPricing = priceElement_r31; return ctx_r33.selectedIndex = i_r32; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 49);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 50);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const priceElement_r31 = ctx.$implicit;
    const i_r32 = ctx.index;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", i_r32);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(priceElement_r31.productName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", priceElement_r31.price, " ", priceElement_r31.currencyCode, "");
} }
function UserPaymentComponent_ng_template_19_div_1_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 35);
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("jhiTranslate", ctx_r30.errorMessage);
} }
function UserPaymentComponent_ng_template_19_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "fa-icon", 24);
    i0.ɵɵlistener("click", function UserPaymentComponent_ng_template_19_div_1_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r37); const modal_r25 = i0.ɵɵnextContext().$implicit; const ctx_r35 = i0.ɵɵnextContext(); modal_r25.close("close"); return ctx_r35.errorMessage = null; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "br");
    i0.ɵɵelement(3, "h5", 37);
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "form", 26, 38);
    i0.ɵɵlistener("ngSubmit", function UserPaymentComponent_ng_template_19_div_1_Template_form_ngSubmit_5_listener() { i0.ɵɵrestoreView(_r37); const _r28 = i0.ɵɵreference(6); const ctx_r38 = i0.ɵɵnextContext(2); return ctx_r38.onSubmitPayment(_r28); });
    i0.ɵɵtemplate(7, UserPaymentComponent_ng_template_19_div_1_div_7_Template, 7, 4, "div", 39);
    i0.ɵɵelementStart(8, "div", 30);
    i0.ɵɵtemplate(9, UserPaymentComponent_ng_template_19_div_1_span_9_Template, 1, 1, "span", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "br");
    i0.ɵɵelementStart(11, "div", 32);
    i0.ɵɵelement(12, "button", 40);
    i0.ɵɵelementStart(13, "button", 34);
    i0.ɵɵlistener("click", function UserPaymentComponent_ng_template_19_div_1_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r37); const modal_r25 = i0.ɵɵnextContext().$implicit; const ctx_r39 = i0.ɵɵnextContext(); modal_r25.close("close"); return ctx_r39.errorMessage = null; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "br");
    i0.ɵɵelementStart(15, "div", 41);
    i0.ɵɵelementStart(16, "div", 42);
    i0.ɵɵelement(17, "img", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 42);
    i0.ɵɵelement(19, "img", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 42);
    i0.ɵɵelement(21, "img", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 42);
    i0.ɵɵelement(23, "img", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", ctx_r26.pricingList);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r26.errorMessage);
} }
function UserPaymentComponent_ng_template_19_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelementStart(1, "fa-icon", 24);
    i0.ɵɵlistener("click", function UserPaymentComponent_ng_template_19_div_2_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r43); const modal_r25 = i0.ɵɵnextContext().$implicit; const ctx_r41 = i0.ɵɵnextContext(); modal_r25.close("close"); ctx_r41.errorMessage = null; return ctx_r41.isSuccessful = false; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "br");
    i0.ɵɵelement(3, "br");
    i0.ɵɵelement(4, "h5", 51);
    i0.ɵɵelement(5, "br");
    i0.ɵɵelementStart(6, "button", 34);
    i0.ɵɵlistener("click", function UserPaymentComponent_ng_template_19_div_2_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r43); const modal_r25 = i0.ɵɵnextContext().$implicit; const ctx_r44 = i0.ɵɵnextContext(); modal_r25.close("close"); ctx_r44.errorMessage = null; return ctx_r44.isSuccessful = false; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function UserPaymentComponent_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, UserPaymentComponent_ng_template_19_div_1_Template, 24, 2, "div", 22);
    i0.ɵɵtemplate(2, UserPaymentComponent_ng_template_19_div_2_Template, 7, 0, "div", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.isSuccessful);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.isSuccessful);
} }
export class UserPaymentComponent extends BaseComponent {
    constructor(userService, eventManager, userVoucherService, sessionStorage, ngbModal, pricingService, sessionService, router, activatedRoute, paymentService, trackerService) {
        super(sessionStorage, ngbModal);
        this.userService = userService;
        this.eventManager = eventManager;
        this.userVoucherService = userVoucherService;
        this.sessionStorage = sessionStorage;
        this.ngbModal = ngbModal;
        this.pricingService = pricingService;
        this.sessionService = sessionService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.paymentService = paymentService;
        this.trackerService = trackerService;
        this.isSuccessful = false;
        this.ngbModalOptions = { backdrop: 'static', keyboard: false };
    }
    ngOnInit() {
        this.paymentService.addCellulantSupport();
        this.userServiceSubscription = this.userService.current().subscribe(user => {
            this.currentUser = user;
            // console.log("currentUser: " + JSON.stringify(this.currentUser));
            this.credits = this.currentUser.credits;
            this.userVoucherServiceSubscription1 = this.userVoucherService.findList(this.currentUser.id).subscribe((res) => {
                console.log(res.body);
                this.currentUserVouchers = res.body || [];
            });
        });
        this.eventManagerSubscription = this.eventManager.subscribe('inukaNgApp.httpError', (errorResponse) => {
            let response = errorResponse.content.status;
            console.log(response);
            if (response === 404) {
                this.errorMessage = 'payment.messages.noVoucher';
                return;
            }
            if (response === 410) {
                this.errorMessage = 'payment.messages.expired';
                return;
            }
            if (response === 403) {
                this.errorMessage = 'payment.messages.forbidden';
                return;
            }
            if (response === 302) {
                this.errorMessage = 'payment.messages.found';
                return;
            }
        });
        this.sessionServiceSubscription = this.pricingService.productsAndPrices().subscribe(map => {
            this.pricingList = map;
            console.log(this.pricingList);
            if (!this.pricingList || this.pricingList.length === 0) {
                console.log('Error: no product found');
            }
        });
        let paymentId = this.activatedRoute.snapshot.queryParams['paymentId'];
        let route = this.router.url;
        console.log('paymentId: ' + paymentId);
        console.log('route: ' + route);
        if (paymentId) {
            this.paymentServiceSubscription = this.paymentService.getPaymentLog(paymentId).subscribe(response => {
                let paymentLog = response.body.payment;
                if (paymentLog.status === "COMPLETED" && !paymentLog.sessionId) {
                    this.openAlertModal(this.paymentFormModal);
                    this.isSuccessful = true;
                    console.log('onPayment: ' + this.isSuccessful);
                }
                else {
                    console.log('not completed yet');
                    this.errorMessage = 'sessionSchedule.dialog.paymentConfirmationTitle';
                }
            });
        }
    }
    openAlertModal(content) {
        this.ngbModal.open(content, this.ngbModalOptions).result.then((result) => console.log(result));
    }
    onVoucherAddition(form) {
        let voucherCode = form.value.voucherCode;
        console.log(voucherCode);
        this.userVoucherServiceSubscription2 = this.userVoucherService.addCode(voucherCode).subscribe((res) => {
            console.log(res);
            if (res.statusText === 'OK') {
                this.isSuccessful = true;
                console.log('onVoucherAddition: ' + this.isSuccessful);
                this.trackerService.sendActivity("userPayment_voucherAdded", { 'voucher_code': res.body.voucher.code });
                this.userVoucherServiceSubscription3 = this.userVoucherService.findList(this.currentUser.id).subscribe((resList) => {
                    console.log(resList.body);
                    this.currentUserVouchers = resList.body || [];
                });
                return;
            }
        });
    }
    onSubmitPayment(form) {
        let pricing = this.pricingList[parseInt(form.value.payment, 10)];
        console.log(pricing);
        if (pricing === null || pricing === undefined) {
            console.log('No payment is selected.');
            this.errorMessage = 'payment.messages.noPayment';
            return;
        }
        let route = 'user-payment';
        this.paymentService.onPayment(pricing, route, null, null);
    }
    ngOnDestroy() {
        if (this.userServiceSubscription) {
            this.userServiceSubscription.unsubscribe();
        }
        if (this.userVoucherServiceSubscription1) {
            this.userVoucherServiceSubscription1.unsubscribe();
        }
        if (this.userVoucherServiceSubscription2) {
            this.userVoucherServiceSubscription2.unsubscribe();
        }
        if (this.userVoucherServiceSubscription3) {
            this.userVoucherServiceSubscription3.unsubscribe();
        }
        if (this.eventManagerSubscription) {
            this.eventManagerSubscription.unsubscribe();
        }
        if (this.sessionServiceSubscription) {
            this.sessionServiceSubscription.unsubscribe();
        }
        if (this.paymentServiceSubscription) {
            this.paymentServiceSubscription.unsubscribe();
        }
    }
}
UserPaymentComponent.ɵfac = function UserPaymentComponent_Factory(t) { return new (t || UserPaymentComponent)(i0.ɵɵdirectiveInject(i1.UserService), i0.ɵɵdirectiveInject(i2.JhiEventManager), i0.ɵɵdirectiveInject(i3.UserVoucherService), i0.ɵɵdirectiveInject(i4.SessionStorageService), i0.ɵɵdirectiveInject(i5.NgbModal), i0.ɵɵdirectiveInject(i6.PricingService), i0.ɵɵdirectiveInject(i7.SessionService), i0.ɵɵdirectiveInject(i8.Router), i0.ɵɵdirectiveInject(i8.ActivatedRoute), i0.ɵɵdirectiveInject(i9.PaymentService), i0.ɵɵdirectiveInject(i10.TrackerService)); };
UserPaymentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UserPaymentComponent, selectors: [["user-payment"]], viewQuery: function UserPaymentComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.voucherFormModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paymentFormModal = _t.first);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 21, vars: 2, consts: [[1, "content-area", 2, "margin-top", "80px"], [1, "container"], ["id", "voucher-list-card", 1, "row"], [1, "col-lg-12"], [1, "e-panel", "card"], [1, "card-header"], ["jhiTranslate", "payment.header.myVouchers", 2, "padding-left", "20px", "padding-top", "5px"], [1, "card-body"], [1, "e-table"], [2, "padding-left", "20px"], ["jhiTranslate", "payment.text"], ["jhiTranslate", "payment.form.addVoucherButton", 1, "btn", "btn-primary", "m-2", 3, "click"], ["class", "mt-2", 4, "ngIf"], ["voucherFormModal", ""], ["paymentFormModal", ""], [1, "mt-2"], [1, "table"], ["scope", "col"], ["jhiTranslate", "payment.table.voucherHeader"], ["jhiTranslate", "payment.table.numberHeader"], [4, "ngFor", "ngForOf"], [1, "modal-body"], [4, "ngIf"], ["style", "text-align: center;", 4, "ngIf"], ["role", "button", "icon", "times", 1, "times", 2, "float", "right", "color", "black", 3, "click"], ["jhiTranslate", "payment.form.title"], [3, "ngSubmit"], ["voucherForm", "ngForm"], [1, "form-group"], ["type", "text", "name", "voucherCode", "ngModel", "", "required", "", 1, "form-control", 3, "placeholder", "click"], [1, "form-text", "text-danger"], [3, "jhiTranslate", 4, "ngIf"], [2, "text-align", "center"], ["type", "submit", "jhiTranslate", "payment.form.addVoucherButton", 1, "btn", "btn-gradient-primary", 2, "margin", "5px"], ["type", "button", "jhiTranslate", "payment.form.close", 1, "btn", "btn-gradient-primary", 2, "margin", "5px", 3, "click"], [3, "jhiTranslate"], ["jhiTranslate", "payment.messages.successful"], ["jhiTranslate", "payment.form.paymentTitle"], ["paymentForm", "ngForm"], ["class", "dropdown-item form-group", 4, "ngFor", "ngForOf"], ["type", "submit", "jhiTranslate", "payment.form.makePaymentButton", 1, "btn", "btn-gradient-primary", 2, "margin", "5px"], [1, "row", 2, "padding-left", "15px"], [1, "column", 2, "float", "left", "width", "15%", "padding", "5px"], ["src", "../../../../content/images/inuka/visa.png", 2, "width", "100%"], ["src", "../../../../content/images/inuka/mastercard.png", 2, "width", "100%"], ["src", "../../../../content/images/inuka/mpesa.png", 2, "width", "100%"], ["src", "../../../../content/images/inuka/airtel.png", 2, "width", "100%"], [1, "dropdown-item", "form-group"], ["type", "radio", "name", "payment", "ngModel", "", "required", "", 3, "value", "click"], [2, "padding-left", "30px"], [2, "float", "right"], ["jhiTranslate", "payment.messages.paymentSuccessful"]], template: function UserPaymentComponent_Template(rf, ctx) { if (rf & 1) {
        const _r46 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵelement(6, "h4", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵelementStart(9, "div");
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵelementStart(11, "p");
        i0.ɵɵelement(12, "span", 10);
        i0.ɵɵelementStart(13, "span");
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "button", 11);
        i0.ɵɵlistener("click", function UserPaymentComponent_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r46); const _r1 = i0.ɵɵreference(18); return ctx.openAlertModal(_r1); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, UserPaymentComponent_div_16_Template, 10, 1, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(17, UserPaymentComponent_ng_template_17_Template, 3, 2, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(19, UserPaymentComponent_ng_template_19_Template, 3, 2, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(14);
        i0.ɵɵtextInterpolate(ctx.credits);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.currentUserVouchers == null ? null : ctx.currentUserVouchers.length) > 0);
    } }, directives: [i11.JhiTranslateDirective, i12.NgIf, i12.NgForOf, i13.FaIconComponent, i14.ɵNgNoValidate, i14.NgControlStatusGroup, i14.NgForm, i14.DefaultValueAccessor, i14.NgControlStatus, i14.NgModel, i14.RequiredValidator, i14.RadioControlValueAccessor], pipes: [i15.TranslatePipe], styles: [""] });
